import { RootState } from '@redux/hooks';
import { candidateDetailsStoreKey } from './candidateDetails.const';

const selectCandidateDetailsState = (state: RootState) => {
  return state[candidateDetailsStoreKey];
};

const getCandidateDetailsAction = (state: RootState) => {
  return selectCandidateDetailsState(state).candidateDetailsAction;
};

const getCandidateDetailsData = (state: RootState) => {
  return selectCandidateDetailsState(state);
};

const getCandidateSummary = (state: RootState) => {
  return selectCandidateDetailsState(state).candidateSummary;
};

const getCandidateSummaryViewAPIStatus = (state: RootState) => {
  return selectCandidateDetailsState(state).candidateSummaryApiStatus;
};

const getCandidateSelectedVideoInterviewUrl = (state: RootState) => {
  return selectCandidateDetailsState(state).selectedVideoInterviewUrl;
};

const getCandidateSelectedVideoInterviewUrlApiStatus = (state: RootState) => {
  return selectCandidateDetailsState(state).selectedVideoInterviewUrlApiStatus;
};

export const candidateDetailsSelectors = {
  getCandidateDetailsData,
  getCandidateDetailsAction,
  getCandidateSummary,
  getCandidateSummaryViewAPIStatus,
  getCandidateSelectedVideoInterviewUrl,
  getCandidateSelectedVideoInterviewUrlApiStatus,
  getLowHappinessNotificationSetting: (state: RootState) =>
    state.candidateDetails.notificationsSettings?.isLowHappiness,
  getSwitchNotificationsStatus: (state: RootState) =>
    state.candidateDetails.switchNotificationsStatus,
  getFetchNotificationsStatus: (state: RootState) =>
    state.candidateDetails.fetchNotificationsStatus,
};
